import { render } from "./Salesman.vue?vue&type=template&id=16293a86"
import script from "./Salesman.vue?vue&type=script&lang=js"
export * from "./Salesman.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\msimi\\Downloads\\WORKZONE\\pvmi-coaching-web-report\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__